import { createContext } from 'react';

// ----------------------------------------------------------------------

export const WebRTCContext = createContext({});
